import { createListenerMiddleware } from '@reduxjs/toolkit';
import { selectUserId } from '@entities/account';
import { clearUploads, removeUpload } from '@shared/lib/uploads';

export const createUploadsListener = (uploadFiles: Map<string, File>) => {
  const listener = createListenerMiddleware();

  listener.startListening({
    actionCreator: removeUpload,
    effect: ({ payload }) => {
      uploadFiles.delete(payload);
    },
  });

  listener.startListening({
    actionCreator: clearUploads,
    effect: () => {
      uploadFiles.clear();
    },
  });

  listener.startListening({
    predicate: (_action, state, previousState) =>
      selectUserId(state as RootState) !== selectUserId(previousState as RootState),
    effect: (_action, { dispatch }) => {
      dispatch(clearUploads());
    },
  });

  return listener;
};
